import { render, staticRenderFns } from "./e-select-dialog.vue?vue&type=template&id=2b637c4b&scoped=true"
import script from "./e-select-dialog.vue?vue&type=script&lang=js"
export * from "./e-select-dialog.vue?vue&type=script&lang=js"
import style0 from "./e-select-dialog.vue?vue&type=style&index=0&id=2b637c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b637c4b",
  null
  
)

export default component.exports